import store from '@/store'
import { CastType } from '@/types/casts'
import { computed } from '@vue/composition-api'
import { getCastLayoutView, getTestingLayouts, CastLayoutView } from '../utils/castlayouts'

const useCastLayouts = () => {
  const currentCast = computed(() => store.state.events.currentCast)
  const castType = computed(() => {
    if (currentCast.value === null) return null
    return currentCast.value.castType ?? CastType.Plain
  })
  const castLayoutView = computed(() => {
    if (getTestingLayouts().value !== null) {
      if (process.env.NODE_ENV !== 'test') {
        console.error('getCastLayout is set to test mode, make sure that TESTING_LAYOUTS.layout === null')
      }
      return getTestingLayouts().value
    }
    if (currentCast.value === null) return null
    return getCastLayoutView(currentCast).value
  })

  return {
    castType,
    castLayoutView,
    isBroadcastView: computed(() => castLayoutView.value === CastLayoutView.Broadcast),
    isCasterView: computed(() => castLayoutView.value === CastLayoutView.Caster),
    isMobileView: computed(() => castLayoutView.value === CastLayoutView.Mobile),
    isProducerView: computed(() => castLayoutView.value === CastLayoutView.Producer),
    isStationView: computed(() => castLayoutView.value === CastLayoutView.Station)
  }
}

export default useCastLayouts
